import React from 'react';
import FilterBadge from './FilterBadge';
import { Box } from '@amzn/awsui-components-core';
import { ContentAudience } from '@amzn/awscat-pattern-library-service-model';
import { FilterType } from './FilterBadge';
import { ContentVisibilitySlicerId, RUMEventTracking } from '../../../monitoring';
import { useFeatureFlag } from '../../../contexts/FeatureFlagContext';

const VisibilityTypeSlicer = () => {
  const isEarlySharingEnabled = useFeatureFlag('EarlySharing');

  return (
    <div className="filter-badge-slicers">
      <Box color="text-body-secondary" margin={{ right: 's', left: 'l' }}>
        Visibility:
      </Box>
      {isEarlySharingEnabled ? (
        <>
          <RUMEventTracking id={ContentVisibilitySlicerId.Internal}>
            <FilterBadge
              filterType={FilterType.AudienceType}
              filterText={ContentAudience.INTERNAL}
              displayLabel="Internal"
            />
          </RUMEventTracking>
          <RUMEventTracking id={ContentVisibilitySlicerId.External}>
            <FilterBadge
              filterType={FilterType.AudienceType}
              filterText={ContentAudience.EXTERNAL}
              displayLabel="External"
            />
          </RUMEventTracking>
        </>
      ) : (
        <>
          <RUMEventTracking id={ContentVisibilitySlicerId.Internal}>
            <FilterBadge
              filterType={FilterType.AudienceType}
              filterText={ContentAudience.INTERNAL}
            />
          </RUMEventTracking>
          <RUMEventTracking id={ContentVisibilitySlicerId.Public}>
            <FilterBadge filterType={FilterType.AudienceType} filterText={ContentAudience.PUBLIC} />
          </RUMEventTracking>
        </>
      )}
    </div>
  );
};

export default VisibilityTypeSlicer;
